module.exports = __webpack_public_path__ + "static/img/zs1.22b0023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/zs1.png
// module id = 9by3
// module chunks = 181